import * as ss from 'superstruct';

/**
 * Google Local Services Ads leads, read from the stream's Google Ads ad
 * account through the agency management account's global OAuth token.
 */
export const GoogleLsaLeadInputStreamSource = ss.type({
  name: ss.literal('google-lsa-lead'),
});

export type GoogleLsaLeadInputStreamSource = ss.Infer<
  typeof GoogleLsaLeadInputStreamSource
>;
